module.exports = __webpack_public_path__ + "img/5.79bf301e.png";